export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SITE = {
  name: "On Point Homes",
  tagline: "Built With Intention. Built For You.",
  phone: "(208) 206-9096",
  email: "mark@onpoint-homes.com",
  instagram: "https://www.instagram.com/onpoint.homes",
  instagramHandle: "@onpoint.homes",
  region: "Idaho's Treasure Valley",
};

// PLACEHOLDER photography — swap with real On Point Homes project photos
export const IMAGES = {
  hero: "/homes/hero.webp",
  heroAlt: "New construction home built by On Point Homes — charcoal and white exterior with three-car garage",
  exterior2: "https://images.unsplash.com/photo-1628744448840-55bdb2497bd4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsdXh1cnklMjBjdXN0b20lMjBob21lJTIwZXh0ZXJpb3IlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzg4Nzk1NDkxfDA&ixlib=rb-4.1.0&q=85",
  interior1: "https://images.unsplash.com/photo-1599696848652-f0ff23bc911f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxoaWdoJTIwZW5kJTIwYXJjaGl0ZWN0dXJhbCUyMGludGVyaW9yJTIwbGl2aW5nJTIwb29tfGVufDB8fHx8MTc4ODc5NTQ5MXww&ixlib=rb-4.1.0&q=85",
  interior2: "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxoaWdoJTIwZW5kJTIwYXJjaGl0ZWN0dXJhbCUyMGludGVyaW9yJTIwbGl2aW5nJTIwcm9vbXxlbnwwfHx8fDE3ODg3OTU0OTF8MA&ixlib=rb-4.1.0&q=85",
  idaho1: "https://images.unsplash.com/photo-1505547735609-676a8f04dc42?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxpZGFobyUyMG1vdW50YWluJTIwbGFuZHNjYXBlJTIwbmF0dXJlfGVufDB8fHx8MTc4ODc5NTQ5MXww&ixlib=rb-4.1.0&q=85",
  idaho2: "https://images.unsplash.com/photo-1599584290793-3cef41047738?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxpZGFobyUyMG1vdW50YWluJTIwbGFuZHNjYXBlJTIwbmF0dXJlfGVufDB8fHx8MTc4ODc5NTQ5MXww&ixlib=rb-4.1.0&q=85",
  craft1: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=85&w=1400&auto=format&fit=crop",
  craft2: "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?q=85&w=1400&auto=format&fit=crop",
  home1: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=85&w=1600&auto=format&fit=crop",
  home2: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=85&w=1600&auto=format&fit=crop",
  home3: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?q=85&w=1600&auto=format&fit=crop",
  home4: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=85&w=1600&auto=format&fit=crop",
};

export const NAV_LINKS = [
  { label: "Available Homes", to: "/available-homes" },
  { label: "Custom Homes", to: "/custom-homes" },
  { label: "Our Work", to: "/our-work" },
  { label: "Our Process", to: "/our-process" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Let's Talk",
    text: "Every great home starts with a conversation. We sit down together, listen to how you live, what you love, and what you need — no pressure, no pitch. Just an honest talk about whether we're the right fit for each other.",
  },
  {
    n: "02",
    title: "Plan",
    text: "We align on budget, homesite, and scope. You'll know what things cost and why, with transparent pricing and a realistic timeline before anything is set in stone.",
  },
  {
    n: "03",
    title: "Design & Selections",
    text: "This is where your home takes shape. We walk you through every finish, fixture, and detail — guiding you with a builder's eye so the choices feel exciting, not overwhelming.",
  },
  {
    n: "04",
    title: "Build",
    text: "We're on site, hands-on, every week. You'll get regular updates, walk the home at key milestones, and always know exactly where things stand.",
  },
  {
    n: "05",
    title: "Final Walkthrough",
    text: "Before keys change hands, we walk every inch together. Details matter — we don't consider a home finished until you'd be proud to call it yours.",
  },
];

export const COMMUNITIES = {
  riverwalk: {
    name: "River Walk Ranch",
    links: [
      { label: "Official Community Site", url: "https://riverwalkmiddleton.com/" },
      { label: "Instagram", url: "https://www.instagram.com/riverwalkmiddleton" },
    ],
  },
  osprey: {
    name: "Osprey Estates",
    links: [
      { label: "Official Community Site", url: "https://ospreyestates-idaho.com/" },
      { label: "Instagram", url: "https://www.instagram.com/ospreyestates.idaho" },
    ],
  },
};

export const communityFor = (home) => {
  const hay = `${home.address} ${home.city}`.toLowerCase();
  if (hay.includes("founder") || hay.includes("middleton")) return COMMUNITIES.riverwalk;
  if (hay.includes("chicken hawk") || hay.includes("osprey")) return COMMUNITIES.osprey;
  return null;
};

export const STATUS_COLORS = {
  "Available": "bg-[#4E735B] text-white",
  "Coming Soon": "bg-[#A37C45] text-white",
  "Under Construction": "bg-[#6B7280] text-white",
  "Sold": "bg-[#4B4B4B] text-white",
};

// Base pool lives in the DB (admin Site Photos tab). This is only a fallback if the pool is empty.
export const PHOTO_POOL = ["/homes/hero.webp"];

export const formatPrice = (p) =>
  p ? `$${p.toLocaleString("en-US")}` : "Price Upon Request";

export const resolveImage = (url) =>
  url && url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;
